import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { GlobalState } from '@/redux/store';

import { getIsBot } from '../analytics';
import { getClientIpAddress } from '../browser';
import { getDeployment } from '../config';
import { fetchItemCarousels } from './itemCarousel.api';
import { shouldFetchCarousel } from './itemCarousel.selectors';
import { FetchItemCarouselsPayload } from './itemCarousel.types';

type FetchItemCarouselsParams = {
    itemId: number;
    shouldUseSignalsBoost?: boolean;
    useNewSimilarItems?: boolean;
    useScoutCategories?: boolean;
    vectorVersion?: string;
};

export const loadItemCarousels = createAsyncThunk<
    FetchItemCarouselsPayload,
    FetchItemCarouselsParams,
    { state: GlobalState }
>(
    'la/domain/items/fetchItemCarousels',
    async ({ itemId, shouldUseSignalsBoost, useNewSimilarItems, useScoutCategories, vectorVersion }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const ipAddress = getClientIpAddress(state);
        const isBot = getIsBot(state);
        const { payload: carousels } = await fetchItemCarousels({
            authToken,
            deployment,
            ipAddress,
            isBot,
            itemId,
            useNewSimilarItems,
            useScoutCategories,
            useSignalsBoost: shouldUseSignalsBoost,
            vectorVersion,
        });
        return { carousels, itemId };
    },
    {
        condition: (arg) => arg.itemId > 0,
    }
);

type FetchItemCarouselsIfNeededParams = {
    itemId: number;
    shouldUseSignalsBoost?: boolean;
    useNewSimilarItems?: boolean;
    useScoutCategories?: boolean;
    vectorVersion?: string;
};

export const fetchItemCarouselsIfNeeded = createAsyncThunk<void, FetchItemCarouselsIfNeededParams>(
    'la/domain/items/fetchItemCarouselsIfNeeded',
    async (
        { itemId, shouldUseSignalsBoost, useNewSimilarItems, useScoutCategories, vectorVersion },
        { dispatch, getState }
    ) => {
        const state = getState();
        if (shouldFetchCarousel(state, itemId)) {
            await dispatch(
                loadItemCarousels({
                    itemId,
                    shouldUseSignalsBoost,
                    useNewSimilarItems,
                    useScoutCategories,
                    vectorVersion,
                })
            );
        }
    }
);
